<template lang="pug">
  div.map-container.navigation-control
    div.toolbar.toolbar--big.toolbar--bordered
      div.line
        h1.title Карта
        form(@submit.stop.prevent="").search
          e-suggestion(
          v-if="currentCar && currentCar.id"
          placeholder="Искать вдоль маршрута"
          @selectItem="selectWaypoint"
          name="route"
          :model="suggestionMapSearch"
          :useInnerSearch="true"
          :options="waypointListData"
          )
          e-suggestion(
          v-else
          placeholder="Введите № автомобиля"
          @selectItem="selectCar"
          name="auto"
          :model="suggestionMapSearch"
          :useInnerSearch="true"
          :options="items.data"
          )

    div.new-map
      div(ref="map" v-once)#map.bigmap
      template(v-if="currentCar && currentCar.id")
        transition(name="fade")
          div.legend.cuscroll.open.currentCar
            e-perfect-scrollbar
              div.head
                div.subtitle {{currentCar.name}}
                span(@click="boundCar").legend__close
              div(v-if="currentCar.status_id === STATUS_ACTIVE").type-group
                div.route-info
                  div.route-info-line
                    label Начало работы:
                    span {{currentCar.himanizeStartAt}}
                  div.route-info-line
                    label Окончание работы:
                    span {{currentCar.himanizeEndAt}}
              div(v-else).type-group
                div.route-info
                  div.route-info-line
                    label Машина не на линии
                    span

              div.type-group.route
                div.group.flex
                  template(
                  v-if="currentCar.status_id === STATUS_ACTIVE"
                  v-for="instruction, index in currentCarInstructions"
                  )
                    template(
                    v-if="currentCar.routeData.waypointIndices.indexOf(instruction.index) > -1"
                    )
                      div.type
                        div(
                        v-bind:class="{ 'passed': instruction.waypointStatus == 0, 'active': instruction.waypointStatus == 1, 'coming': instruction.waypointStatus > 1 }"
                        ).marker
                          span.station {{instruction.road}}
                          span.time {{instruction.time}}

      template(v-else)
        transition(name="fade")
          div.legend.cuscroll.open.cat-list
            e-perfect-scrollbar
              div.head
                h2.title Сейчас на линии
                div.legend-info {{activeItems}} из {{totalItems}} машин
              div.type-group
                div.group.flex
                  template(v-if="items && items.data && items.data.length")
                    div(
                    v-for="item in items.data"
                    @click.stop.prevent="onCarClick(item)"
                    ).type
                      // .planned .inactive .active
                      div(:class="getClassByStatusId(item.status_id)").marker
                        span {{item.name}}
                        div.progress
                          div.progress-loaded(:style="`width: ${item.progress}%`")

              div.type-group
                div.group.info
                  div.type
                    span.marker.active На линии
                  div.type
                    span.marker.inactive На ремонте
                  div.type
                    span.marker.planned Недоступен

</template>

<script>
  import 'leaflet'
  import {MAP, TILE_LAYER} from '../../../config/map.js'
  import {POLYGON} from "../../../config/polygon"
  import mapMixin from '../../../mixins/map-mixin.js'
  import CarDrawer from '../utils/CarDrawer'
  import {map as mapEndpoints, mongoApi} from '../../../api/api-endpoints.js'
  import {NavigationControlRoute} from "../../../config/mongo"
  import {STATUS_ACTIVE, STATUS_PLANED} from "../../../config/config"
  import {NOTIFY} from "../../../config/config"

  const STATUS_LEAVED = 0
  const STATUS_AT_THAT_POINT = 1
  const STATUS_FUTURE = 2

  export default {
    name: 'appeals-map',
    data () {

      this.mapLayers = null
      this.map = null
      this.carsMoveInterval = null

      return {
        suggestionMapSearch: {
          route: '',
          auto: ''
        },
        legendMode: 'all',
        currentCar: {},
        currentCarPosition: {}
      }
    },
    mixins: [mapMixin],
    computed: {
      waypointListData () {
        let list = []
        if (this.currentCarInstructions) {
          this.currentCarInstructions.forEach((instruction, i) => {
            if (instruction.road && this.currentCar.routeData.waypointIndices.indexOf(instruction.index) > -1) {
              list.push({
                id: i,
                name: instruction.road,
                coords: this.currentCar.routeData.coordinates[instruction.index]
              })
            }
          })
        }
        return list
      },
      STATUS_ACTIVE () {
        return STATUS_ACTIVE
      },
      totalItems () {
        if (this.items && this.items._meta) {
          return this.items._meta.totalCount
        }
        return 0
      },
      activeItems () {
        let active = 0
        if (this.items && this.items.data) {
          this.items.data.forEach(v => {
            if (v.status_id && v.status_id === STATUS_ACTIVE) {
              active++
            }
          })
        }
        return active
      },
      currentCarInstructions () {
        if (this.currentCar.routeData.instructions) {
          let {nearWearIndex = null, lat, lng} = this.currentCar
          if (nearWearIndex !== null) {
            return this.coloriseInstructionsWithPointCompare(nearWearIndex)
          }
          // by default
          return this.coloriseInstructions(lat, lng)
        }
        return []
      },
      layersConf() {
        return this.getLayersConf()
      },
      mapBorders () {
        return this.$store.getters.readUrlEndpoint(mapEndpoints.mo())
      },
      items () {
        return this.$store.getters.readUrlEndpoint(this.getItemsEndpoint())
      },
      currentTime () {
        return this.$store.getters.readUrlEndpoint(this.getCurrentTimeEndpoint())
      }
    },
    created () {
      this.markerClickSubs = this.$emitter.listen('marker.click', e => this.onCarMarkerClick(e))
    },
    mounted () {
      if (this.items && this.items.data) {
        this.items.data.forEach(v => {
          if (v.himanizeLate && v.himanizeLate.toString().length > 0 && v.status_id === STATUS_ACTIVE) {
            this.$notify.warning({
              title: v.name,
              message: v.himanizeLate,
              duration: NOTIFY.NOTIFY_TIMEOUT,
              type: 'warning',
              position: 'bottom-left',
              customClass: 'map-warning'
            })
          }
        })
      }
      this.carsMoveStart()
    },
    destroyed () {
      this.markerClickSubs.unsubscribe()
      this.carsMoveEnd()
    },
    methods: {
      coloriseInstructionsWithPointCompare (nearWearIndex) {
        // let waypointIndices = this.currentCar.routeData.waypointIndices || []
        let instructions = this.currentCar.routeData.instructions.slice()
        for (let i = 0; i < instructions.length; i++) {
          instructions[i].waypointStatus = STATUS_LEAVED
          if (instructions[i].index >= nearWearIndex) {
            instructions[i].waypointStatus = STATUS_FUTURE
          }
          if (!instructions[i].distance && instructions[i - 1]) {
            instructions[i].distance = instructions[i - 1].distance
          }
          if (instructions[i].index == nearWearIndex) {
            instructions[i].waypointStatus = STATUS_AT_THAT_POINT
          }
        }
        return instructions
      },
      coloriseInstructions (lat, lng) {
        let nearWearAt = 0
        let coordinates = this.currentCar.routeData.coordinates || []
        // fist step get near wear by route coords
        for (let j = 0; j < coordinates.length; j++) {
          if (this.isNearWear({
            lat,
            lng
          }, {
            lat: coordinates[j][0],
            lng: coordinates[j][1]
          })) {
            nearWearAt = j
            break
          }
        }
        // colorise insructions
        let instructions = this.currentCar.routeData.instructions.slice()
        for (let i = 0; i < instructions.length; i++) {
          instructions[i].waypointStatus = STATUS_LEAVED
          if (instructions[i].index >= nearWearAt) {
            instructions[i].waypointStatus = STATUS_FUTURE
          }
          if (!instructions[i].distance && instructions[i - 1]) {
            instructions[i].distance = instructions[i - 1].distance
          }
          // car on point
          let coords = coordinates[instructions[i].index]
          if (this.isNearWear({
            lat,
            lng
          }, {
            lat: coords[0],
            lng: coords[1]
          })) {
            instructions[i].waypointStatus = STATUS_AT_THAT_POINT
            // set leaved all prev
            for (let j = 0; j < i; j++) {
              instructions[j].waypointStatus = STATUS_LEAVED
            }
          }
        }
        return instructions
      },
      drawMarkers () {
        if (this.items && this.items.data) {
          let markers = []
          this.items.data.forEach(v => {
            if (v.lat && v.lng) {
              markers.push(v)
            }
          })
          this.carDrawer.drawAllCarMarkers(markers)
        }
      },
      refreshCarsData: async function (disableFitToBounds = true) {
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getItemsEndpoint()
        })
        if (this.items && this.items.data) {
          this.items.data.forEach(car => {
            if (this.currentCar && car.id == this.currentCar.id) {
              this.currentCar = Object.assign({}, car)
              this.carDrawer.drawCarRoute(this.currentCar, {
                disableFitToBounds
              })
            }
          })
        }
        this.drawMarkers()
      },
      startMoveInterval () {
        if (this.carsMoveInterval) {
          clearInterval(this.carsMoveInterval)
        }
        this.carsMoveInterval = setInterval(() => {
          this.refreshCarsData()
        }, 2500)
      },
      carsMoveStart: async function () {
        try {
          await this.refreshCarsData(false)
        } catch (e) {
          console.error(e)
        }
        this.startMoveInterval()
      },
      carsMoveEnd () {
        if (this.carsMoveInterval) {
          clearInterval(this.carsMoveInterval)
        }
      },
      selectWaypoint (item) {
        this.suggestionMapSearch.route = item.name
        this.map.setView(item.coords, 18)
      },
      selectCar (item) {
        this.suggestionMapSearch.auto = item.name
        this.expandCar(item)
      },
      isNearWear (coordFirst = {}, coordNext = {}, precision = 3) {
        if (coordFirst && coordNext && coordFirst.lat && coordNext.lat) {
          const lat = (+coordFirst.lat).toFixed(precision) === (+coordNext.lat).toFixed(precision)
          const lng = (+coordFirst.lng).toFixed(precision) === (+coordNext.lng).toFixed(precision)
          return lat && lng
        }
        return false
      },
      getClassByStatusId (statusId) {
        let status = ''
        if (statusId === STATUS_ACTIVE) {
          status = ' active'
        } else if (statusId === STATUS_PLANED) {
          status = ' planned'
        } else {
          status = ' inactive'
        }
        return status
      },
      boundCar () {
        this.currentCar = Object.create(null)
        this.carDrawer.removeCarRoute()
        if (this.prevPostiton && this.prevPostiton.zoom) {
          this.map.setView(
            this.prevPostiton.center,
            this.prevPostiton.zoom
          )
        }
      },
      expandCar (car) {
        this.prevPostiton = {
          zoom: this.map.getZoom(),
          center: this.map.getCenter()
        }
        this.currentCar = Object.assign({}, car)
        this.carDrawer.drawCarRoute(this.currentCar)
      },
      onCarClick (car) {
        this.expandCar(car)
      },
      onCarMarkerClick (evt) {
        let {marker, routeExist = false} = evt
        if (!routeExist) {
          this.expandCar(marker.options.model)
        }
        console.log(evt)
      },
      getMapConfig(key) {
        return MAP[key]
      },
      getMapPolygon () {
        return POLYGON
      },
      drawTiles () {
        L.tileLayer(TILE_LAYER, {}).addTo(this.map)
      },
      afterMapInit() {
        this.carDrawer = new CarDrawer(this.map, this)
        this.drawMarkers()
        // this.carDrawer.drawMarkers(this.carsMarker)
      },
      /* required for use in map-poup.vue */
      popupIsOpened (markerInfo){
        return false
      },
      /* required for use in map-poup.vue */
      registerOpenPopup (markerInfo){},
      destroyMap () {
        console.log('destroyed')
        this.$emitter.emit('geo.destroyMap', {})
        // this.map.remove()
        this.map = null
      },
      getItemsEndpoint () {
        return mongoApi.getCollectionItems(NavigationControlRoute, {
          query: {
            updateIntervalInMs: 5 * 1000,
            signalUpdateIntervalInMs: 3 * 1000,
            pointStopIntervalInMs: 2 * 60 * 1000,
            offlineIntervalInMs: 10 * 60 * 1000,
            maxSpeedInKmH: 60
          }
        })
      }
    },
    asyncData ({store, route, fromRoute, methods}) {
      let promises = []

      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.mo(),
        fromCache: true
      }))

      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getItemsEndpoint()
      }))

      if (promises.length === 0){
        return Promise.resolve(1)
      }

      return Promise.all(promises)
    }
  };
</script>

<style>
  .leaflet-routing-container{
    display: none;
  }
</style>
